<div class="view-pdf-modal">
  <div class="modal-header">
    <h3 class="modal-title">{{ modalTitle }}</h3>
    <div class="header-actions">
      <i class="fa fa-times hoverable" (click)="cancel()" title="Close"></i>
    </div>
  </div>

  <div class="modal-body">
    @if (showFormLoader) {
<div class="formLoader">
      <i class="fa fa-spin fa-spinner"></i>
    </div>
}
    @if (!showFormLoader) {
<div class="modal-message">
      @if (errorMessage) {
<div class="error-message">{{ errorMessage }}</div>
}
      @if (!errorMessage) {
<div>PDF is opened in a new tab.</div>
}
    </div>
}
  </div>

  @if (errorMessage) {
<div class="modal-footer">
    <button type="button" class="cancel-btn" (click)="cancel()">Close</button>
  </div>
}
</div>
